var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoVehicles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77226 9.12704L5.8335 16.5001H34.1668L31.2037 9.12264C30.9313 8.4445 30.2739 8.00012 29.5431 8.00012H10.4346C9.70204 8.00012 9.04348 8.44657 8.77226 9.12704Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68421 16.6985L3.26153 19.1252C3.09406 19.293 3 19.5203 3 19.7573V26.1429C3 27.1861 3.84568 28.0318 4.88889 28.0318H35.2105C36.1988 28.0318 37 27.2306 37 26.2423V19.7573C37 19.5203 36.9059 19.293 36.7385 19.1252L34.3158 16.6985",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 21.2224H23.7777",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2222 24.0557H23.7777",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 20.2779H7.67257C7.17842 20.2779 6.77783 20.6785 6.77783 21.1726V23.1609C6.77783 23.6551 7.17842 24.0557 7.67257 24.0557H11.5498C12.0439 24.0557 12.4445 23.6551 12.4445 23.1609V21.1726C12.4445 20.6785 12.0439 20.2779 11.5498 20.2779Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3276 20.2779H28.4504C27.9563 20.2779 27.5557 20.6785 27.5557 21.1726V23.1609C27.5557 23.6551 27.9563 24.0557 28.4504 24.0557H32.3276C32.8217 24.0557 33.2223 23.6551 33.2223 23.1609V21.1726C33.2223 20.6785 32.8217 20.2779 32.3276 20.2779Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94434 27.8335V30.7662C3.94434 31.7545 4.74551 32.5557 5.73381 32.5557H8.76597C9.75427 32.5557 10.5554 31.7545 10.5554 30.7662V27.8335",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4443 27.8335V30.7662C29.4443 31.7545 30.2455 32.5557 31.2338 32.5557H34.266C35.2543 32.5557 36.0554 31.7545 36.0554 30.7662V27.8335",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3887 16.0279C30.3887 15.4698 30.2787 14.9171 30.0652 14.4015C29.8516 13.8859 29.5385 13.4173 29.1439 13.0227C28.7492 12.628 28.2807 12.315 27.7651 12.1014C27.2494 11.8878 26.6968 11.7779 26.1387 11.7779C25.5806 11.7779 25.0279 11.8878 24.5123 12.1014C23.9966 12.315 23.5281 12.628 23.1335 13.0227C22.7388 13.4173 22.4258 13.8859 22.2122 14.4015C21.9986 14.9171 21.8887 15.4698 21.8887 16.0279",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoVehicles);
export default __webpack_public_path__ + "static/media/Auto & Vehicles.75c6e296e08c9d688e37b03fdc498897.svg";
export { ForwardRef as ReactComponent };